exports = module.exports = require("./../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".axis-checkout{background-color:#fff;border-radius:6px;padding:4rem;box-shadow:0px 0px 40px rgba(113,113,113,0.18)}.axis-checkout .form-group{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center}.axis-checkout .first-name,.axis-checkout .last-name{-ms-flex:1;flex:1}.axis-checkout .first-name:not(:last-child),.axis-checkout .last-name:not(:last-child){margin-right:2rem}.axis-checkout .card-number{-ms-flex:1;flex:1}.axis-checkout .exp-month,.axis-checkout .exp-year,.axis-checkout .cvc{-ms-flex:1;flex:1}.axis-checkout .exp-month:not(:last-child),.axis-checkout .exp-year:not(:last-child),.axis-checkout .cvc:not(:last-child){margin-right:2rem}.axis-checkout .zip-code,.axis-checkout .country{-ms-flex:1;flex:1}.axis-checkout .zip-code:not(:last-child),.axis-checkout .country:not(:last-child){margin-right:2rem}.axis-checkout .country>span{display:block}.axis-checkout .btn{-ms-flex:1;flex:1}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/sass-loader!./src/index.scss
// module id = 17
// module chunks = 0 1